import { Directive, HostListener, input } from '@angular/core';

// https://stackoverflow.com/a/66272398

@Directive({
  selector: '[panNumericInput]',
  standalone: true,
})
export class NumericInputDirective {
  public numbersOnly = input<boolean>();

  readonly allowedKeys: string[] = ['Backspace', 'ArrowUp', 'ArrowDown', '.'];

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    if (
      this.allowedKeys.indexOf(e.key) > -1 ||
      (e.key === 'a' && e.ctrlKey) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey) || // Cmd+A (Mac)
      (e.key === 'c' && e.metaKey) || // Cmd+C (Mac)
      (e.key === 'v' && e.metaKey) || // Cmd+V (Mac)
      (e.key === 'x' && e.metaKey) // Cmd+X (Mac)
    ) {
      return;
    }

    if (e.key === ' ' || isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (/[^0-9]/.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
